// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section__3k2qG","Section--divided":"Section--divided__2XBSd"};